import React, { useState } from 'react'
import { Column, Row, Expaned } from '@/components/layout/layout'
import FormTitle from '../../../components/form/form-title/form-title'
import { Table, Spin } from 'antd'
import { IUser } from '@/model/types/user'
import { ColumnsType } from 'antd/es/table'
import Iconfont from '@/components/iconfont/iconfont'
import { getBEMCls } from '@/utils/classname'
import StockUpdateDetail from './stock-update-detail'

import './stock-update-detail.scss'
import { useRequest } from 'ahooks'
import useSetDataTogether from '@/utils/hooks/useSetDataTogether'
import { $post } from '@/api'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage } from '@/utils/layer'
import { Goods } from '@/model/types/goods'

interface UpdateDetailInfoProps {
    inventyId: number
}

export interface IUpdateDetail {
    update_time: string
    creator: {
        id: number
        user: IUser
    }
    status: number
    inventory_goods: InventoryGoods[]
}

export interface InventoryGoods {
    goods: Goods
    id: number
    remark: string
    inventory: number
    stock_actual: number
    stock_difference: number
    stock_original: number
}

const ReduceDetailInfo: React.FC<UpdateDetailInfoProps> = props => {
    const [updateDetail, setUpdateDetail] = useState<null | IUpdateDetail>(null)
    const [loading, setLoading] = useState<boolean>(true)

    const setAllData = useSetDataTogether()

    useRequest(
        () =>
            $post({
                url: '/warehouse/getinventorydetail',
                params: {
                    inventory_id: props.inventyId,
                },
            }),
        {
            onSuccess: (res: IUpdateDetail) => {
                setAllData(() => {
                    // 批量更新
                    setUpdateDetail(res)
                    setLoading(false)
                })
            },
        },
    )

    const columns: ColumnsType<InventoryGoods> = [
        {
            title: '#',
            key: 'index',
            width: 40,
            align: 'center',
            render: (value, record, index) => index + 1,
        },
        {
            title: '商品名',
            key: 'name',
            ellipsis: true,
            dataIndex: 'goods',
            render: val => val.name,
        },
        {
            title: '上架',
            width: 70,
            dataIndex: 'goods',
            render: val => (
                <Row>
                    {val.status === 0 || val.on_mall ? (
                        <React.Fragment>
                            <span className={cls('icon')}>
                                {val.on_mall && <Iconfont name="icon2shangjiaweishangcheng" size={20} />}
                            </span>
                            <span>
                                {val.status === 0 && (
                                    <Iconfont
                                        name="icon2shangjiashouyintai"
                                        size={20}
                                        style={{
                                            marginLeft: '8px',
                                        }}
                                    />
                                )}
                            </span>
                        </React.Fragment>
                    ) : (
                        <span>
                            <Iconfont name="iconweishangjia1" size={35}></Iconfont>
                        </span>
                    )}
                </Row>
            ),
        },
        {
            title: '系统库存',
            key: 'stock_original',
            align: 'right',
            dataIndex: 'stock_original',
        },
        {
            title: '实际库存',
            key: 'stock_actual',
            align: 'right',
            dataIndex: 'stock_actual',
        },
        {
            title: '库存差异',
            key: 'stock_difference',
            align: 'right',
            dataIndex: 'stock_difference',
        },
        {
            title: '备注',
            key: 'remark',
            dataIndex: 'remark',
            align: 'right',
            render: val => (val ? <div className={cls('remark')}>{val}</div> : '-'),
        },
    ]

    const cls = (...arg: string[]) => getBEMCls('stock-update-detail', ...arg)

    return (
        <BaseDrawer
            isShow
            title="盘点单详情"
            width={700}
            onClose={() => {
                layerManage.pop()
            }}
        >
            <Column data-height-100p>
                <Expaned>
                    <Spin spinning={loading}>
                        <StockUpdateDetail
                            creator={updateDetail?.creator}
                            status={updateDetail?.status}
                            update_time={updateDetail?.update_time}
                        />
                        <FormTitle title="盘点清单" hasLine={false}></FormTitle>
                        <div
                            style={{
                                width: 'calc(100% - 32px)',
                                marginLeft: '16px',
                            }}
                        >
                            <Table
                                columns={columns}
                                bordered
                                pagination={false}
                                dataSource={updateDetail?.inventory_goods}
                                rowKey={reocrd => reocrd.id}
                                scroll={{ x: 'max-content', y: 500 }}
                            />
                        </div>
                    </Spin>
                </Expaned>
            </Column>
        </BaseDrawer>
    )
}

export default ReduceDetailInfo
